import styled from '@emotion/styled';
import { Row } from 'react-bootstrap';

const PaddedRow = styled(Row)`
    padding: 0.5% 0;
`;

export default PaddedRow;
